export default __webpack_public_path__ + "static/media/tour1.12932c9f.png";